import React, { useState } from 'react';
import { Card, Form, Input, Select, Button, message } from 'antd';
import { addBlogPost } from '../../api/mockData';
import './index.css';

const WritePostPage = () => {
  const [form] = Form.useForm();
  
  // 模拟已存在的标签数据
  const [availableTags] = useState(['技术', '生活', '学习笔记', 'React', 'JavaScript']);

  const onFinish = (values) => {
    console.log('Received values:', values);
    
    // 添加新文章到数据源
    try {
      addBlogPost(values);
      message.success('文章发布成功！');
      form.resetFields();
    } catch (error) {
      message.error('发布文章时出现错误：' + error.message);
    }
  };

  return (
    <div className="write-post-container">
      <Card className="write-post-header" title="写文章" extra="创建新文章" />
      
      <Card className="write-post-card">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            name="title"
            label="标题"
            rules={[{ required: true, message: '请输入文章标题!' }]}
          >
            <Input placeholder="输入文章标题" />
          </Form.Item>

          <Form.Item
            name="content"
            label="内容"
            rules={[{ required: true, message: '请输入文章内容!' }]}
          >
            <Input.TextArea 
              rows={6} 
              placeholder="输入文章内容" 
            />
          </Form.Item>

          <Form.Item
            name="excerpt"
            label="摘要"
            rules={[{ required: true, message: '请输入文章摘要!' }]}
          >
            <Input.TextArea 
              rows={3} 
              placeholder="输入文章摘要" 
            />
          </Form.Item>

          <Form.Item
            name="tags"
            label="标签"
            rules={[{ required: false }]}
          >
            <Select
              mode="tags"
              placeholder="选择或输入标签"
              style={{ width: '100%' }}
            >
              {availableTags.map(tag => (
                <Select.Option key={tag} value={tag}>{tag}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              发布文章
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default WritePostPage;